import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';
import TextWithBackground from 'components/TextWithBackground';

const TextWrapper = ({ onRight, copy, children, ...rest }) => (
	<LineWrapper>
		<div
			className={cn(s.wrap, {
				[s.sideRight]: onRight
			})}
		>
			<TextWithBackground
				tag={'p'}
				bg={'transparent'}
				{...rest}
				className={s.copy}
			>
				{copy}
			</TextWithBackground>
			{children}
		</div>
	</LineWrapper>
);

export default TextWrapper;



// WEBPACK FOOTER //
// ./components/TextWrapper/index.js